import { restHeartClient } from '..'

/**
 * 上传文件。
 * @param db
 * @param collection
 * @param file
 * @param contentType
 * @param fileId
 * @param onProgress
 */
export function uploadFile(db: string, collection: string, file: Blob, contentType = 'text/plain', fileId?: string, onProgress = progressEvent => {}) {
	const form = new FormData()
	form.append('file', file)
	form.append(
		'properties',
		JSON.stringify({
			contentType,
		})
	)
	const config = {
		onUploadProgress: onProgress,
	}
	if (fileId) {
		return restHeartClient.put(`${db}/${collection}.files/${fileId}`, form, config)
	} else {
		return restHeartClient.post(`${db}/${collection}.files`, form, config)
	}
}
